/**
 * toastContainerPosition — keep the app-wide toast container clear of the
 * builder header's presence-avatar cluster.
 *
 * `App.js` mounts ONE global `react-toastify` `ToastContainer` at
 * `position="top-right"`, which react-toastify positions `fixed` at a flat
 * `top: 1em` (16px) via its own CSS class
 * (`.Toastify__toast-container--top-right`). `components/WheelHeader/styles.js`'s
 * `HeaderMainDiv` renders in NORMAL FLOW at the very top of every builder page
 * (`height: 8vh; min-height: 60px`) and is not `position: fixed` — so at any
 * viewport height where the header is taller than 16px (i.e. essentially
 * always: the 60px floor alone clears it), a toast paints directly over
 * whatever sits in the header's top-right corner, including the account
 * avatar (hw-0914-staging-p2-a2s-confirm-closes-capture-pane: a toast fired
 * from an "Add to Segments" confirm covered the avatar at x 1107-1421,
 * y 22-80 vs. avatar y 15-57).
 *
 * `TOAST_CONTAINER_TOP` overrides react-toastify's flat `top: 1em` with the
 * SAME `max(floor, 8vh)` shape the header itself uses, plus a fixed clearance
 * margin, so the toast's top edge always sits at or below the header's
 * bottom edge regardless of viewport height (see
 * `toastContainerPosition.test.js` for the proof over a wide height range).
 */
export const HEADER_MIN_HEIGHT_PX = 60;
export const HEADER_HEIGHT_VH = 8;
export const TOAST_HEADER_CLEARANCE_PX = 24;

export const TOAST_CONTAINER_TOP = `max(${
  HEADER_MIN_HEIGHT_PX + TOAST_HEADER_CLEARANCE_PX
}px, calc(${HEADER_HEIGHT_VH}vh + ${TOAST_HEADER_CLEARANCE_PX}px))`;
